import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./style/app.scss";
import { Provider } from "react-redux";
import store from "./state/store";
import { Toaster } from "sonner";
import { toasterConfig } from "./notify/toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Toaster {...toasterConfig} />
      <Provider store={store}>
        <App />
      </Provider>
  </React.StrictMode>
);
